import(/* webpackMode: "eager" */ "/app/src/app/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["AppProvider"] */ "/app/src/components/app-provider/app-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileMenu"] */ "/app/src/components/layout/mobile-menu/mobile-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DebugPanel"] */ "/app/src/components/test/debug-panel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebMCPTools"] */ "/app/src/features/webmcp/webmcp-tools.tsx");
